<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12">
        <b-card>
          <div slot="header">
            <i class="icon-note"></i> Libro Diario - Comprobantes por Día
            <i @click="visible = !visible" style="cursor: pointer;" :class="{ 'fa fa-angle-up pull-right': visible, 'fa fa-angle-down pull-right': !visible }"> </i>            
          </div>
          
          <b-collapse v-model="visible">
          <b-row class="cuerpo">
            <b-col cols="11" col md="2" class="pr-6">
              <label for="desde"> Desde:&nbsp; </label><br />
              <date-picker
                id="desde"
                :lang="lang"
                v-model="desde"
                format="YYYY-MM-DD"
                type="date"
                style="width: 100%"
                :disabled="cargandoDatos"
              >
              </date-picker>
            </b-col>
            <b-col cols="11" col md="2" class="pl-sm-6">
              <label for="hasta"> Hasta:&nbsp; </label><br />
              <date-picker
                id="hasta"
                :lang="lang"
                v-model="hasta"
                format="YYYY-MM-DD"
                type="date"
                style="width: 100%"
                :disabled="cargandoDatos"
              >
              </date-picker>
            </b-col>
            <b-col cols="11" col md="1">
              <b-form-group id="input-group-1" label="Tipo:">
                <b-form-select
                  v-model="filtros.tipo"
                  :options="tiposoptions"
                  value-field="id"
                  text-field="descripcion"
                  style="min-width:80px"
                  :disabled="cargandoDatos"
                ></b-form-select>
              </b-form-group>
            </b-col>
           <b-col cols="11" col md="2">
              <b-form-group label="Centro">
                <b-input-group>
                  <b-form-select
                    v-model="filtros.centro_id"
                    :options="centros"
                    value-field="id"
                    text-field="nombre"
                    class="mb-3"
                    style="min-width:80px"
                  >
                  </b-form-select>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="6" col md="3" ml-md="1">
              <button
                class="btn btn-sm btn-success text-white"
                @click="cargarDatos('n')"
                style="margin-top: 2.4em; margin-right:2em"
                :disabled="cargandoDatos"
              >
                <i class="fa fa-search"></i> Cargar Datos
              </button>

              <button
                class="btn btn-sm btn-success text-white"
                @click="cargarDatos('s')"
                style="margin-top: 2.4em"
                :disabled="cargandoDatos"
              >
                <i class="fa fa-file-excel-o"></i> Exportar Excel
              </button>
            </b-col>
          </b-row>
        </b-collapse>
        </b-card>
      </b-col>
    </b-row>

    <b-row v-show="!registros.length">
      <b-col cols="12">
        <b-card>
          <p class="cuerpo text-center" style="margin: 0;">
            {{
              yaSeRealizoPrimeraBusqueda
                ? "No hay datos disponibles."
                : "Seleccione un rango de fecha"
            }}
          </p>
        </b-card>
      </b-col>
    </b-row>

    <b-row v-show="registros.length">
      <b-col cols="12">
        <b-card>
          <b-col class="table-responsive">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th></th>
                  <th class="negrita" style="color:gray">Fecha:</th>
                  <th class="negrita text-right" style="color:gray">
                    Debe:
                    <span class="text-right negrita"
                      ><h5 style="color:green">
                        {{ formatoNumero(suma(registros, "debito")) }}
                      </h5></span
                    >
                  </th>
                  <th class="negrita text-right" style="color:gray">
                    Haber:
                    <span class="text-right negrita"
                      ><h5 style="color:green">
                        {{ formatoNumero(suma(registros, "credito")) }}
                      </h5></span
                    >
                  </th>
                </tr>
              </thead>
              <tbody v-for="(r, i) in registros" :key="`${i}`">
                <tr class="fs1">
                  <td style="width: 25px;" class="text-center">
                    <i
                      class="fa"
                      @click="mostrar(r)"
                      style="cursor:pointer"
                      v-bind:class="{
                        'fa-plus-square-o': !r.mostrarDetalles,
                        'fa-minus-square-o': r.mostrarDetalles
                      }"
                    ></i>
                  </td>
                  <td>
                    <b>{{ r.fecha }}</b>
                  </td>
                  <td class="text-right debe_haber negrita">
                    {{
                      r.debito | currency("", 2, { thousandsSeparator: "," })
                    }}
                  </td>
                  <td class="text-right debe_haber negrita">
                    {{
                      r.credito | currency("", 2, { thousandsSeparator: "," })
                    }}
                  </td>
                </tr>
                <tr v-show="r.mostrarDetalles">
                  <td colspan="6" class="tdpl6">
                    <table class="table table-hover">
                      <tbody
                        v-for="(dd1, id11) in r.detalles1"
                        :key="`${i}-${id11}`"
                      >
                        <tr class="fs2">
                          <td style="width: 25px;" class="text-center">
                            <i
                              class="fa"
                              @click="mostrar(dd1)"
                              style="cursor:pointer"
                              v-bind:class="{
                                'fa-plus-square-o': !dd1.mostrarDetalles,
                                'fa-minus-square-o': dd1.mostrarDetalles
                              }"
                            ></i>
                          </td>
                          <td>{{ dd1.tipo }}</td>
                          <td
                            class="text-right debe_haber negrita"
                            style="color:gray"
                          >
                            {{
                              dd1.debito
                                | currency("", 2, { thousandsSeparator: "," })
                            }}
                          </td>
                          <td
                            class="text-right debe_haber negrita"
                            style="color:gray"
                          >
                            {{
                              dd1.credito
                                | currency("", 2, { thousandsSeparator: "," })
                            }}
                          </td>
                        </tr>
                        <tr v-show="dd1.mostrarDetalles">
                          <td colspan="6" class="tdpl6">
                            <table class="table table-hover">
                              <tbody
                                v-for="(d2, id12) in dd1.detalles2"
                                :key="`${i}-${id11}-${id12}`"
                              >
                                <tr class="fs3">
                                  <td style="width: 25px;" class="text-center">
                                    <i
                                      class="fa"
                                      @click="mostrar(d2)"
                                      style="cursor:pointer"
                                      v-bind:class="{
                                        'fa-plus-square-o': !d2.mostrarDetalles,
                                        'fa-minus-square-o': d2.mostrarDetalles
                                      }"
                                    ></i>
                                  </td>
                                  <td class="cuentas">
                                    <b-link
                                      target="_blank"
                                      :to="{
                                        name: 'pdf-comprobante',
                                        params: { id: d2.id, name: d2.codigo }
                                      }"
                                      >{{ d2.codigo }}
                                    </b-link>
                                  </td>
                                  <td>
                                    <em><small>Concepto: </small></em
                                    >{{ d2.concepto }}
                                  </td>
                                  <td class="text-right debe_haber">
                                    {{
                                      d2.debito
                                        | currency("", 2, {
                                          thousandsSeparator: ","
                                        })
                                    }}
                                  </td>
                                  <td class="text-right debe_haber">
                                    {{
                                      d2.credito
                                        | currency("", 2, {
                                          thousandsSeparator: ","
                                        })
                                    }}
                                  </td>
                                </tr>
                                <tr v-show="d2.mostrarDetalles">
                                  <td colspan="6" class="tdpl6">
                                    <table
                                      class="table table-hover"
                                      style="font-size: 1.05em;"
                                    >
                                      <tbody>
                                        <tr>
                                          <td style="width:60px"></td>
                                          <td>
                                            <small><i>Cuenta:</i></small>
                                          </td>
                                          <td>
                                            <small
                                              ><i>Descripción Cuenta:</i></small
                                            >
                                          </td>
                                          <td></td>
                                          <td></td>
                                        </tr>
                                        <tr
                                          v-for="(d3, id13) in d2.detalles3"
                                          class="fs4"
                                          :key="`${i}-${id11}-${id12}-${id13}`"
                                        >
                                          <td style="width:60px"></td>
                                          <td class="cuentas">
                                            {{ d3.cuenta }}
                                          </td>
                                          <td>{{ d3.nombre }}</td>
                                          <td class="text-right debe_haber">
                                            {{
                                              d3.debito
                                                | currency("", 2, {
                                                  thousandsSeparator: ","
                                                })
                                            }}
                                          </td>
                                          <td class="text-right debe_haber">
                                            {{
                                              d3.credito
                                                | currency("", 2, {
                                                  thousandsSeparator: ","
                                                })
                                            }}
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
              <tbody></tbody>
            </table>
          </b-col>
          <br />
          <b-pagination
            :hidden="totalRows < filtros.pagesize"
            class="pull-right"
            :disabled="cargandoDatos"
            v-model="filtros.currentPage"
            :total-rows="totalRows"
            :per-page="filtros.pagesize"
          ></b-pagination>
          <!--	<b-col class="text-right">
						<span class="btn btn-success">Total Debe: {{formatoNumero(suma(registros,'debito'))}}</span>
						&nbsp;
						<span class="btn btn-success">Total Haber: {{formatoNumero(suma(registros,'credito'))}}</span>
					</b-col> -->
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Vue2Filters from "vue2-filters";
import toastr from "toastr";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/es";

import { cambiarFormatoFecha } from "../../shared/utils";

export default {
  mixins: [Vue2Filters.mixin],
  name: "LDiario-form",
  components: { DatePicker },
  mounted() {
    this.cargarTiposComprobantesyCentros();
  },
  data: () => {
    return {
      filtros: {
        pagesize: 100,
        currentPage: 1,
        tipo: undefined,
        centro_id: undefined,
        area: undefined,
        desde: undefined,
        hasta: undefined,
        excel: "n"
      },
      lang: { formatLocale: { firstDayOfWeek: 1 } },
      tiposoptions: [{ id: 0, descripcion: "" }],
      desde: undefined,
      hasta: undefined,
      cargandoDatos: false,
      registros: [],
      totalRows: 0,
      centros: [],
      yaSeRealizoPrimeraBusqueda: false,
      visible: true
    };
  },
  watch: {
    "filtros.currentPage": {
      handler: function() {
        this.cargarDatos();
      }
    }
  },
  methods: {
    suma(objeto, campo) {
      return objeto
        ? objeto.reduce((a, c) => a + (c[campo] ? parseFloat(c[campo]) : 0), 0)
        : 0;
    },
    formatoNumero(num, dec = 2) {
      return num && !isNaN(num)
        ? num.toFixed(dec).replace(/\d(?=(\d{3})+\.)/g, "$&,")
        : 0;
    },
    mostrar(registro) {
      registro.mostrarDetalles = !registro.mostrarDetalles;
    },
    formatoFecha(date) {
      // eslint-disable-next-line no-undef
      return moment(date).format("YYYY-MM-DD");
    },

    async cargarTiposComprobantesyCentros() {
      try {
        this.centros = [];
        let model ={}
        model.empresa_id = this.empresaId;
        // eslint-disable-next-line no-undef
        let {data} = await axios.post("/api/catalogos/centros",{model});
        this.centros = data.data ? data.data : [];
        this.centros.unshift({ id: undefined, nombre: "Todos" });
        // eslint-disable-next-line no-undef
        let tiposComprobantes = await axios.post(
          "/api/catalogos/tipo-comprobantes"
        );
        this.tiposoptions =
          tiposComprobantes.data && tiposComprobantes.data.data
            ? tiposComprobantes.data.data
            : [];
        this.tiposoptions.unshift({ id: undefined, descripcion: "Todos" });
      } catch (error) {
        console.log(error);
      }
    },
    async cargarDatos(excel = "n") {
      if (!this.desde)
        return toastr["warning"]("Favor ingresar una fecha valida en Desde");
      if (!this.hasta)
        return toastr["warning"]("Favor ingresar una fecha valida en Hasta");

      this.yaSeRealizoPrimeraBusqueda = true;
      this.filtros.desde = cambiarFormatoFecha(this.desde);
      this.filtros.hasta = cambiarFormatoFecha(this.hasta);
      this.filtros.excel = excel;
      this.filtros.empresa_id = this.empresaId;
      this.cargandoDatos = true;
      try {

        if (excel == "s") {
          toastr["info"](
            "Generando Excel de Comprobantes de Diario. Favor Espere"
          );
          try {
            // eslint-disable-next-line no-undef
            const response = await axios.post("/api/reportes/ldiario", this.filtros,
              {
                responseType: 'arraybuffer',
              }
            );
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            // eslint-disable-next-line no-undef
            let desde = moment(this.desde).format("YYYY-MM-DD");
            // eslint-disable-next-line no-undef
            let hasta = moment(this.hasta).format("YYYY-MM-DD");
            link.setAttribute('download', `LibroDiario-${desde} al ${hasta}.xlsx`);
            document.body.appendChild(link);
            link.click();
          } catch(error){
            console.log("aca anda");
            console.log(error);
          }

        } else {
          // eslint-disable-next-line no-undef
          let {data} = await axios.post("/api/reportes/ldiario", this.filtros);
          this.registros = [];
          this.totalRows = data && data.total ? data.total : 0;
          if (data && data.data) {
            let datos = data.data;
            datos.forEach(d => {
              if (d.detalles1) {
                d.detalles1.forEach(d1 => {
                  d1.mostrarDetalles = false;
                  if (d1.detalles2)
                    d1.detalles2.forEach(d2 => {
                      d2.mostrarDetalles = false;
                      if (d2.detalles3)
                        d2.detalles3.forEach(
                          d3 => (d3.mostrarDetalles = false)
                        );
                    });
                });
              }

              this.registros.push({
                fecha: cambiarFormatoFecha(d.fecha),
                debito: d.debito,
                credito: d.credito,
                detalles1: d.detalles1,
                mostrarDetalles: true
              });
            });
          }
        }
      } catch (error) {
        console.log(error);
      }
      this.cargandoDatos = false;
    },

  },
  computed: {
    ...mapGetters("authentication", ["empresaId"])
  }
};
</script>
<style scoped>
.tdpl6 {
  padding-left: 30px !important;
}
.negrita {
  font-weight: bold;
}
.debe_haber {
  width: 200px;
}
.cuentas {
  width: 150px;
}
.table {
  margin: 0;
}
.table thead th {
  border: solid #c8ced3;
  border-width: 0 0 2px 0;
}
.fs1 {
  font-size: 1.2em;
}
.fs2 {
  font-size: 1.1em;
}
.fs3 {
  font-size: 1em;
}
.fs4 {
  font-size: 0.9em;
}
.table td {
  padding: 0;
  border: none;
}
.card-body{
  padding:0;
}
.cuerpo{
  padding:1.25rem;
}
</style>
